import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';
import { ApprovalState, LegalFees } from '../../../../models/FlowOfFunds/flow-of-funds.model';

export interface SetLegalFeesAgreementRequest {
    engagementId: number;
    targetState: ApprovalState;
}

export const SetLegalFeesAgreement = createAsyncThunk(
    'flowOfFunds/setLegalFeesAgreement',
    async (params: SetLegalFeesAgreementRequest, dispatch: any) => {
        const axios = dispatch.getState().core.axios;

        try {
            const response = await axios.put(
                `/api/flowOfFunds/${params.engagementId}/legalFees/agreement`,
                {
                    targetState: params.targetState,
                }
            );

            if (response.status !== 200) {
                throw new Error('Failed to save the agreement');
            }

            return response.data as LegalFees;
        } catch (error) {
            createNotification('Could not save the agreement.', 'error');
            throw error;
        }
    }
);
